import { Breadcrumb } from '@components/common/breadcrumb';
import { withTheme } from '@emotion/react';
import React from 'react';
import { DestinationLinkBuilder, LinkItem, Name } from '@model/iceberg/geography';
import { useI18NextContext } from '@components/hooks';
import { Item } from '@components/breadcrumbs/item';
import { Page, TripTypes } from '@model/common';
import { getGuideLabel } from './GuidesBreadcrumb';

export interface GuideBreadcrumbProps {
  destination: Name;
  guide: string;
  guideDisplay: string;
  tripType?: TripTypes;
  guidePage: Page.TRAVEL_GUIDES | Page.VIDEO_GUIDES | Page.EXPERIENCES;
}

const GuideBreadcrumbComponent = ({
  destination: { path, display },
  guide,
  guideDisplay,
  tripType,
  guidePage
}: GuideBreadcrumbProps) => {
  const t: any = useI18NextContext();
  const builder: DestinationLinkBuilder = new DestinationLinkBuilder();
  const destinationLink: LinkItem = builder.getDestinationLink(path, tripType);
  const guidesLink: LinkItem = builder.getGuidesLink(path, guidePage, tripType);
  const guideLink: LinkItem = builder.getGuideLink(path, guide, guidePage, tripType);
  const items: Array<Item> = [
    { ...destinationLink, display },
    { ...guidesLink, display: t(getGuideLabel(guidePage)) },
    { ...guideLink, display: guideDisplay }
  ];
  return <Breadcrumb items={items} tripType={tripType} />;
};

export const GuideBreadcrumb = withTheme(GuideBreadcrumbComponent);
